@if (previewUrl || getImageUrl()) {
    <img [alt]="contact?.name" [src]="previewUrl || getImageUrl()" />
} @else {
    <i class="fas fa-user"></i>
}

@if (editable) {
    <div class="edit-overlay">
        <i class="fas fa-pencil-alt"></i>
    </div>
}
